var _circle, _g, _rect, _rect2, _rect3, _rect4, _rect5, _circle2, _g2, _rect6, _circle3, _g3, _rect7, _circle4, _g4, _rect8, _circle5, _circle6, _g5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLists = function SvgLists(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 363,
    height: 131
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1016",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(115 12)",
    fill: "#81e6d9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12097",
    transform: "translate(122.032 17.715)",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 3.266,
    cy: 3.266,
    transform: "translate(.812)",
    r: 3.266
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M0 10.391a3.972 3.972 0 0 1 4.079-3.86"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25730",
    d: "M8.158 10.391a3.972 3.972 0 0 0-4.079-3.86"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 6071",
    width: 126.738,
    height: 10,
    rx: 5,
    transform: "translate(161.942 18)",
    fill: "#e1e5f8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 6082",
    width: 10,
    height: 10,
    rx: 5,
    transform: "translate(144.942 18)",
    fill: "#e1e5f8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 6083",
    width: 10,
    height: 10,
    rx: 5,
    transform: "translate(144.942 46)",
    fill: "#e1e5f8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 6084",
    width: 10,
    height: 10,
    rx: 5,
    transform: "translate(144.942 75)",
    fill: "#e1e5f8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 6085",
    width: 10,
    height: 10,
    rx: 5,
    transform: "translate(144.942 103)",
    fill: "#e1e5f8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1016",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(115 40)",
    fill: "#81e6d9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12097",
    transform: "translate(122.032 45.715)",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 3.266,
    cy: 3.266,
    transform: "translate(.812)",
    r: 3.266
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M0 10.391a3.972 3.972 0 0 1 4.079-3.86"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25730",
    d: "M8.158 10.391a3.972 3.972 0 0 0-4.079-3.86"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 6071",
    width: 152.376,
    height: 10,
    rx: 5,
    transform: "translate(161.942 46)",
    fill: "#e1e5f8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1016",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(115 69)",
    fill: "#81e6d9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12097",
    transform: "translate(122.032 75)",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 3.266,
    cy: 3.266,
    transform: "translate(.812)",
    r: 3.266
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M0 10.391a3.972 3.972 0 0 1 4.079-3.86"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25730",
    d: "M8.158 10.391a3.972 3.972 0 0 0-4.079-3.86"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 6071",
    width: 104.176,
    height: 10,
    rx: 5,
    transform: "translate(161.942 75)",
    fill: "#e1e5f8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1016",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(115 97)",
    fill: "#81e6d9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12097",
    transform: "translate(122.032 102.715)",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 3.266,
    cy: 3.266,
    transform: "translate(.812)",
    r: 3.266
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M0 10.391a3.972 3.972 0 0 1 4.079-3.86"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25730",
    d: "M8.158 10.391a3.972 3.972 0 0 0-4.079-3.86"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 6071",
    width: 152.376,
    height: 10,
    rx: 5,
    transform: "translate(161.942 103)",
    fill: "#e1e5f8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1021",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(1 31)",
    fill: "#e1e5f8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1022",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(25 17)",
    fill: "#e1e5f8"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12102",
    transform: "translate(-13)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1013",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(34 34)",
    fill: "#373a95"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12091"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11348",
    transform: "translate(49.662 51.899)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 49",
    cx: 2.748,
    cy: 2.748,
    r: 2.748,
    fill: "#81e6d9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 39",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M13.081 2.749H32.12"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 50",
    cx: 2.748,
    cy: 2.748,
    r: 2.748,
    transform: "translate(0 11.136)",
    fill: "#81e6d9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 40",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M13.081 13.884H32.12"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 51",
    cx: 2.748,
    cy: 2.748,
    r: 2.748,
    transform: "translate(0 22.272)",
    fill: "#81e6d9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 41",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M13.081 25.019H32.12"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7966",
    fill: "none",
    d: "M0 0h363v131H0z"
  })));
};
export default SvgLists;